import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './ResultPage.css';

const ResultPage = () => {
  const { examCode } = useParams();
  const [resultData, setResultData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [linkCopied, setLinkCopied] = useState(false);

  useEffect(() => {
    const fetchResult = async () => {
      try {
        await axios.post(`${process.env.REACT_APP_API_URL}/exam/${examCode}/finish`);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/result/${examCode}`);
        setResultData(response.data);
      } catch (err) {
        setError(err.response?.data?.error || 'Erro ao sincronizar e carregar os resultados');
      } finally {
        setIsLoading(false);
      }
    };

    fetchResult();
  }, [examCode]);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    } catch (err) {
      console.error('Erro ao copiar link:', err);
    }
  };

  if (isLoading) {
    return <div className="loading">Carregando resultados...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  const { exam } = resultData;
  const totalCorrect = exam.pontuacao;
  const isApproved = totalCorrect > 0;

  return (
    <div className="result-container">
      <h2>Resultado da Avaliação</h2>

      <div className="result-summary">
        <div className={`exam-status full-width ${isApproved ? 'approved' : 'failed'}`}>
          <span className="status-icon">{isApproved ? '✅' : '⚠️'}</span>
          {isApproved ? (
            <>
              <strong>APROVADO</strong>
              <p>Parabéns! Falta apenas um último passo para ser aluno FAPAM: você receberá um link para a matrícula, fique atento ao e-mail cadastrado e WhatsApp.</p>
            </>
          ) : (
            <>
              <strong>REPROVADO</strong>
              <p>Infelizmente você não atingiu a pontuação mínima para aprovação.</p>
            </>
          )}
        </div>
      </div>

      <div className="share-link">
        <p>Compartilhe este link para acessar esses resultados:</p>
        <div className="share-link-row">
          <input
            type="text"
            readOnly
            value={window.location.href}
            onClick={(e) => e.target.select()}
          />
          <button type="button" className="copy-btn" onClick={handleCopyLink}>
            {linkCopied ? 'Copiado!' : 'Copiar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultPage;
